var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCta04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: #f4e211;\n      }\n\n      .st3 {\n        fill: #f5f1e5;\n      }\n\n      .st4 {\n        fill: #2ca0ff;\n      }\n\n      .st5 {\n        fill: #ff715d;\n      }\n\n      .st1 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3.5px;\n      }\n\n      .st6 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.3,73.9s13.2,11.2,41.9,6.8c-2.9,22.6-18,35.8-27,34.3-9.1-1.5-19.3-18.7-14.9-41.1h0Z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 64,
    cy: 64,
    r: 64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "left_eyebrow7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4,
    cy: 22.9,
    rx: 7,
    ry: 12.7,
    transform: "translate(12.5 59.7) rotate(-84.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nose_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.9,45.1s-16.7,17.2-7.5,26.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right_eyebrow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.6,
    cy: 39.9,
    rx: 6.9,
    ry: 12.6,
    transform: "translate(27.1 120.8) rotate(-67.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left_wye"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.4,41c1.9-3.5,5.8-5.3,9.6-4.5,3.6.7,6.3,3.7,6.9,7.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right_eye7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.8,56.4c2.4-3.2,6.7-4.4,10.3-2.9,3.2,1.4,5.2,4.7,5,8.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 23.5,
    cy: 61,
    r: 7.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 95.1,
    cy: 76.9,
    r: 7.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "mouth7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.3,73.9s13.2,11.2,41.9,6.8c-2.9,22.6-18,35.8-27,34.3-9.1-1.5-19.3-18.7-14.9-41.1h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.2,102.5c4.4-.2,8.9,1.9,11.6,5.3,1.7,2.2,2.8,5.2,1.7,7.7-1.2,2.5-4.2,3.6-7,4-4.9.6-10-.4-14.3-2.7-1.5-.8-2.9-1.8-3.8-3.3-3.7-6,7.3-10.9,11.8-11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.5,74.9h0c-.2,4.5,2.5,8.6,6.7,10.1s9.5,2.8,15,2.7c4.7,0,8.7-3.2,9.8-7.7h0c0-.1-31.5-5.1-31.5-5.1Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCta04);
export default __webpack_public_path__ + "static/media/cta-04.895c6db4054a4d7d0900118eefbf86ac.svg";
export { ForwardRef as ReactComponent };